import type { BaseComponentProps } from "@neru/types";

interface SpacerProps extends BaseComponentProps {
  divider?: boolean;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  vertical?: boolean;
}

const sizeMapX = {
  lg: "px-4",
  md: "px-2",
  sm: "px-1",
  xl: "px-6",
  xs: "px-0.5",
};

const sizeMapY = {
  lg: "py-4",
  md: "py-2",
  sm: "py-1",
  xl: "py-6",
  xs: "py-0.5",
};

export const Spacer = ({
  className = "",
  divider = false,
  size = "md",
  vertical = false,
  ...props
}: SpacerProps) => {
  const marginClass = vertical ? sizeMapY[size] : sizeMapX[size];

  let dividerClass = "";
  if (divider) {
    dividerClass = vertical
      ? "h-full border-t border-primary-200"
      : "w-full border-l border-primary-200";
  }

  const displayClass = vertical ? "block" : "inline-block";

  return (
    <span
      className={`
        ${displayClass}
        ${marginClass}
        ${className}
      `}
      {...props}
    >
      {divider ? (
        <span
          className={`
            ${displayClass}
            ${dividerClass}
          `}
        />
      ) : null}
    </span>
  );
};
